import React from 'react';
import { Building, Users, Percent, PlusCircle, GraduationCap } from 'lucide-react';

export default function AddStayTab({
  newStay,
  setNewStay,
  PROPRIEDADES,
  handleAddStaySubmit
}) {
  return (
    <div className="max-w-4xl mx-auto space-y-6 animate-fadeIn">
      <div className="bg-white p-8 rounded-3xl shadow-sm border border-slate-200">
        <form onSubmit={handleAddStaySubmit} className="space-y-8">
          
          {/* 1. Morada, Reserva & Configuração do Contrato */}
          <div className="space-y-4">
            <h3 className="text-xs font-black uppercase text-indigo-900 border-b pb-2 flex items-center gap-2">
              <Building size={14} /> 1. Morada, Reserva & Configuração do Contrato
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-xs">
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Apartamento *</label>
                <select
                  value={newStay.propriedade}
                  onChange={(e) => setNewStay({ ...newStay, propriedade: e.target.value })}
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2"
                >
                  {PROPRIEDADES.map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Quarto / ID *</label>
                <input
                  type="text"
                  placeholder="Quarto 1"
                  value={newStay.quarto}
                  onChange={(e) => setNewStay({ ...newStay, quarto: e.target.value })}
                  className="w-full bg-slate-50 border rounded-xl px-4 py-2"
                  required
                />
              </div>
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Data Reserva *</label>
                <input
                  type="date"
                  value={newStay.dataReserva}
                  onChange={(e) => setNewStay({ ...newStay, dataReserva: e.target.value })}
                  className="w-full bg-slate-50 border rounded-xl px-4 py-2"
                  required
                />
              </div>
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Estado do Contrato *</label>
                <select
                  value={newStay.status}
                  onChange={(e) => setNewStay({ ...newStay, status: e.target.value })}
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2"
                >
                  <option value="Ativo">Ativo (A habitar)</option>
                  <option value="Reservado">Reservado</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-6 gap-4 text-xs">
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Data Início *</label>
                <input
                  type="date"
                  value={newStay.checkIn}
                  onChange={(e) => setNewStay({ ...newStay, checkIn: e.target.value })}
                  className="w-full bg-slate-50 border rounded-xl px-4 py-2"
                  required
                />
              </div>
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Data Fim *</label>
                <input
                  type="date"
                  value={newStay.checkOut}
                  onChange={(e) => setNewStay({ ...newStay, checkOut: e.target.value })}
                  className="w-full bg-slate-50 border rounded-xl px-4 py-2"
                  required
                />
              </div>
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Renda Base (€) *</label>
                <input
                  type="number"
                  placeholder="500"
                  value={newStay.renda}
                  onChange={(e) => setNewStay({ ...newStay, renda: e.target.value })}
                  className="w-full bg-slate-50 border rounded-xl px-4 py-2"
                  required
                />
              </div>
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Caução (€)</label>
                <input
                  type="number"
                  placeholder="500"
                  value={newStay.caucao}
                  onChange={(e) => setNewStay({ ...newStay, caucao: e.target.value })}
                  className="w-full bg-slate-50 border rounded-xl px-4 py-2"
                />
              </div>
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Admin Fee (€)</label>
                <input
                  type="number"
                  placeholder="150"
                  value={newStay.adminFee}
                  onChange={(e) => setNewStay({ ...newStay, adminFee: e.target.value })}
                  className="w-full bg-slate-50 border rounded-xl px-4 py-2"
                />
              </div>
              <div>
                <label className="block text-indigo-955 font-bold mb-1.5">Desp. Comuns (€) *</label>
                <input
                  type="number"
                  value={newStay.despesasComuns}
                  onChange={(e) => setNewStay({ ...newStay, despesasComuns: e.target.value })}
                  className="w-full bg-indigo-50 border border-indigo-200 rounded-xl px-4 py-2 font-bold"
                  required
                />
              </div>
            </div>
          </div>

          {/* 2. Dados de Identificação do Inquilino */}
          <div className="space-y-4">
            <h3 className="text-xs font-black uppercase text-indigo-900 border-b pb-2 flex items-center gap-2">
              <Users size={14} /> 2. Dados de Identificação do Inquilino
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-xs">
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Nome Completo *</label>
                <input
                  type="text"
                  placeholder="Clara Dupont"
                  value={newStay.inquilino}
                  onChange={(e) => setNewStay({ ...newStay, inquilino: e.target.value })}
                  className="w-full bg-slate-50 border rounded-xl px-4 py-2"
                  required
                />
              </div>
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Email *</label>
                <input
                  type="email"
                  placeholder="clara@email.com"
                  value={newStay.email}
                  onChange={(e) => setNewStay({ ...newStay, email: e.target.value })}
                  className="w-full bg-slate-50 border rounded-xl px-4 py-2"
                  required
                />
              </div>
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Telemóvel *</label>
                <input
                  type="text"
                  placeholder="+33 6..."
                  value={newStay.telemovel}
                  onChange={(e) => setNewStay({ ...newStay, telemovel: e.target.value })}
                  className="w-full bg-slate-50 border rounded-xl px-4 py-2"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-6 text-xs">
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Nacionalidade *</label>
                <input
                  type="text"
                  placeholder="Francesa"
                  value={newStay.nacionalidade}
                  onChange={(e) => setNewStay({ ...newStay, nacionalidade: e.target.value })}
                  className="w-full bg-slate-50 border rounded-xl px-4 py-2 text-slate-900"
                  required
                />
              </div>
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Idade</label>
                <input
                  type="number"
                  placeholder="23"
                  value={newStay.idade}
                  onChange={(e) => setNewStay({ ...newStay, idade: e.target.value })}
                  className="w-full bg-slate-50 border rounded-xl px-4 py-2"
                />
              </div>
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Ocupação *</label>
                <select
                  value={newStay.ocupacao}
                  onChange={(e) => setNewStay({ ...newStay, ocupacao: e.target.value })}
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2 text-slate-800"
                >
                  <option value="Trabalhador">Trabalhador</option>
                  <option value="Estudante">Estudante</option>
                </select>
              </div>

              {newStay.ocupacao === "Estudante" && (
                <div className="animate-fadeIn">
                  <label className="block text-indigo-955 font-bold mb-1.5 flex items-center gap-1">
                    <GraduationCap size={13} /> Universidade *
                  </label>
                  <input
                    type="text"
                    placeholder="Nova SBE"
                    value={newStay.universidade}
                    onChange={(e) => setNewStay({ ...newStay, universidade: e.target.value })}
                    className="w-full bg-indigo-50 border border-indigo-200 rounded-xl px-4 py-2 text-slate-900"
                    required
                  />
                </div>
              )}
            </div>
          </div>

          {/* 4. Origem do Cliente & Comissões */}
          <div className="space-y-4">
            <h3 className="text-xs font-black uppercase text-indigo-900 border-b pb-2 flex items-center gap-2">
              <Percent size={14} /> 4. Origem do Cliente & Comissões
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-xs">
              <div>
                <label className="block text-slate-500 font-bold mb-1.5">Fechou pela Coolivin? *</label>
                <select
                  value={newStay.origemCoolivin}
                  onChange={(e) => setNewStay({ ...newStay, origemCoolivin: e.target.value })}
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-2 text-slate-800"
                >
                  <option value="Sim">Sim (Direto)</option>
                  <option value="Não">Não (Plataforma Externa)</option>
                </select>
              </div>

              {newStay.origemCoolivin === "Não" && (
                <>
                  <div className="animate-fadeIn">
                    <label className="block text-indigo-955 font-bold mb-1.5">Plataforma *</label>
                    <input
                      type="text"
                      placeholder="Uniplaces"
                      value={newStay.plataformaOrigem}
                      onChange={(e) => setNewStay({ ...newStay, plataformaOrigem: e.target.value })}
                      className="w-full bg-indigo-50 border border-indigo-200 rounded-xl px-4 py-2 text-slate-900"
                      required
                    />
                  </div>
                  <div className="animate-fadeIn">
                    <label className="block text-indigo-955 font-bold mb-1.5">Comissão (€) *</label>
                    <input
                      type="number"
                      placeholder="319.80"
                      value={newStay.comissaoValor}
                      onChange={(e) => setNewStay({ ...newStay, comissaoValor: e.target.value })}
                      className="w-full bg-indigo-50 border border-indigo-200 rounded-xl px-4 py-2 text-slate-900"
                      required
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="pt-4 border-t">
            <button
              type="submit"
              className="w-full bg-slate-950 text-white font-bold py-3.5 rounded-xl uppercase text-[11px] flex items-center justify-center gap-2 hover:bg-slate-900 transition-all"
            >
              <PlusCircle size={14} /> ADICIONAR ESTADIA E SINCRONIZAR
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
